import React from 'react'
import PropTypes from 'prop-types'
import { usePreloadComponentBlueprints } from '../../../api/denali'
import { useAbundanceEngineParameters } from '../../../hooks/useAbundanceEngineParameters'
import Loading from '../../molecules/Loading'
import FadeIn from '../../molecules/Transitions/FadeIn'
import { useIntegrationAuthState } from '../IntegrationAuthProvider/IntegrationAuthContext'
import IntegrationAuthGate from '../IntegrationAuthProvider/IntegrationAuthGate'

function SmartComponentLoader ({ blueprintCode, integration, children, minHeight }) {
  const { isLoading: blueprintsLoading } = usePreloadComponentBlueprints(blueprintCode)
  const abundanceParams = useAbundanceEngineParameters()

  const authState = useIntegrationAuthState(integration, abundanceParams.clientId, {
    enabled: !!integration && !!abundanceParams.clientId
  })

  const authLoading = !!integration && authState.isLoading
  const isLoading = blueprintsLoading || authLoading

  if (isLoading) {
    return (
      <div style={minHeight ? { minHeight } : undefined}>
        <Loading />
      </div>
    )
  }

  if (!integration) {
    return <FadeIn>{children}</FadeIn>
  }

  return (
    <IntegrationAuthGate authState={authState}>
      <FadeIn>{children}</FadeIn>
    </IntegrationAuthGate>
  )
}

SmartComponentLoader.propTypes = {
  blueprintCode: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  integration: PropTypes.string,
  children: PropTypes.node,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default SmartComponentLoader
